/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useState } from 'react';
import { useSendEmailBreakdown } from '../';
import { useMostRecentExamAttempt } from '../../exams';
import { useUserInfo } from '../../accounts';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmailBreakdownButton = ({
  trackId,
  tooltipTitle,
  className,
  language
}) => {
  const {
    userInfo
  } = useUserInfo();
  const [feedbackMessage, setfeedbackMessage] = useState(false);
  const {
    mostRecentExamAttempt
  } = useMostRecentExamAttempt(Number(trackId), language);
  const [sendEmailBreakdown, {
    sendEmailBreakdownLoading,
    sendEmailBreakdownError
  }] = useSendEmailBreakdown();
  const getUpdatedMessage = () => feedbackMessage ? 'learningCenter.exams.finished.checkYourEmail' : 'learningCenter.exams.finished.sendBreakdownWait';
  return sendEmailBreakdownLoading ? /*#__PURE__*/_jsx(UILoadingSpinner, {
    grow: true,
    style: {
      width: 250
    }
  }) : /*#__PURE__*/_jsx(UITooltip, {
    "data-test-id": "email-exam-breakdown-button-tooltip",
    maxWidth: "max-content",
    title: mostRecentExamAttempt && mostRecentExamAttempt.finished ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: getUpdatedMessage(),
      options: {
        emailAddress: userInfo && userInfo.user.emails[0]
      }
    }) : tooltipTitle,
    children: /*#__PURE__*/_jsxs(UILink, {
      className: className,
      "data-test-id": "email-exam-breakdown-button",
      disabled: !!mostRecentExamAttempt && !mostRecentExamAttempt.finished,
      onClick: () => {
        if (!mostRecentExamAttempt) return null;
        return sendEmailBreakdown(mostRecentExamAttempt.id, Number(trackId), mostRecentExamAttempt.language).then(() => {
          setfeedbackMessage(true);
        });
      },
      style: {
        paddingLeft: 20,
        paddingRight: 20
      },
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: 'learningCenter.exams.finished.emailExamBreakdown'
      }), !!sendEmailBreakdownError && /*#__PURE__*/_jsx(UIIcon, {
        name: "warning",
        style: {
          marginLeft: 5
        }
      })]
    })
  });
};
export default EmailBreakdownButton;